import axios from 'axios';
import { BACKEND_URL } from './Constants';
import {
	adminCloseUserOpenReportsMutation,
	adminCreateUserWithEmailMutation,
	adminCreateUserWithPhoneMutation,
	adminDisableProfileMutation,
	adminDisableUserMutation,
	adminEnableProfileMutation,
	adminEnableUserMutation,
	adminExtendValidityProfileMutation,
	adminResetUserPasswordMutation,
	adminUpdateProfileMutation,
	adminMarkUploadedImageAsProfilePictureMutation,
	adminTriggerReindexMutation,
} from './mutations';
import {
	adminFilterQuery,
	adminGetAllOpenReportsQuery,
	adminSearchQuery,
	adminViewProfileQuery,
	adminGetProfileByPhoneQuery,
	adminGetProfileByEmailQuery,
	adminGetUploadDataForProfileQuery
} from './queries';

export const adminUpdateProfile = async (accessToken, key) => {
	const response = await axios.post(
		BACKEND_URL,
		adminUpdateProfileMutation(accessToken, key)
	);
	return response;
};

export const adminFilter = async (
	accessToken,
	filters,
	pageNumber,
	pageSize,
	searchText
) => {
	let query =
		searchText?.length > 0
			? adminSearchQuery(
					accessToken,
					filters,
					pageNumber,
					pageSize,
					searchText
			  )
			: adminFilterQuery(accessToken, filters, pageNumber, pageSize);
	const response = await axios.post(BACKEND_URL, query);
	return response;
};

export const adminViewProfile = async (
	accessToken,
	filters,
	pageNumber,
	pageSize
) => {
	const response = await axios.post(
		BACKEND_URL,
		adminViewProfileQuery(accessToken, filters, pageNumber, pageSize)
	);
	return response;
};

export const adminEnableOrDisableProfile = async (
	accessToken,
	userId,
	enable
) => {
	let query = enable
		? adminEnableProfileMutation(accessToken, userId)
		: adminDisableProfileMutation(accessToken, userId);
	const response = await axios.post(BACKEND_URL, query);
	return response;
};

export const adminEnableOrDisableUser = async (accessToken, userId, enable) => {
	let query = enable
		? adminEnableUserMutation(accessToken, userId)
		: adminDisableUserMutation(accessToken, userId);
	const response = await axios.post(BACKEND_URL, query);
	return response;
};

export const adminProfileValidityExtend = async (accessToken, userId) => {
	const response = await axios.post(
		BACKEND_URL,
		adminExtendValidityProfileMutation(accessToken, userId)
	);
	return response;
};

export const adminGetProfileByPhone = async (accessToken, phone) => {
	const response = await axios.post(
		BACKEND_URL,
		adminGetProfileByPhoneQuery(accessToken, phone)
	);
	return response;
}

export const adminGetProfileByEmail = async (accessToken, email) => {
	const response = await axios.post(
		BACKEND_URL,
		adminGetProfileByEmailQuery(accessToken, email)
	);
	return response;
}

export const adminResetUserPassword = async (accessToken, userId, password) => {
	const response = await axios.post(
		BACKEND_URL,
		adminResetUserPasswordMutation(accessToken, userId, password)
	);
	return response;
};

export const adminCreateUser = async (
	accessToken,
	registrationKey,
	password,
	isRegistrationKeyPhone
) => {
	let query = isRegistrationKeyPhone
		? adminCreateUserWithPhoneMutation(
				accessToken,
				registrationKey,
				password
		  )
		: adminCreateUserWithEmailMutation(
				accessToken,
				registrationKey,
				password
		  );
	const response = await axios.post(BACKEND_URL, query);
	return response;
};

export const adminGetAllOpenReports = async(
	accessToken,
	pageNumber,
	pageSize
) => {
	const response = await axios.post(
		BACKEND_URL,
		adminGetAllOpenReportsQuery(accessToken, pageNumber, pageSize)
	);
	return response.data;
}

export const adminCloseUserOpenReports = async (
  accessToken,
  userId,
  adminReport
) => {
  const response = await axios.post(
    BACKEND_URL,
    adminCloseUserOpenReportsMutation(accessToken, userId, adminReport)
  );
  return response.data;
};

export const adminGetUploadDataForProfile = async (accessToken, userId) => {
	const response = await axios.post(
		BACKEND_URL,
		adminGetUploadDataForProfileQuery(accessToken, userId),
		{timeout: 5000}
	);
	return response.data;
};

export const adminMarkUploadedImageAsProfilePicture = async (accessToken, uploadKeys, userId) => {
	const response = await axios.post(
		BACKEND_URL,
		adminMarkUploadedImageAsProfilePictureMutation(accessToken, uploadKeys, userId),
		{timeout: 5000}
	);
	return response.data;
};

export const adminTriggerReindex = async (accessToken) => {
	const response = await axios.post(
		BACKEND_URL,
		adminTriggerReindexMutation(accessToken)
	);
	return response;
};